<template>
  <div class=""></div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    const params = this.getAutoLoginParams();
    if (params) {
      this.autoLogin(params);
    }
  },
  mounted() {},
  methods: {
    getAutoLoginParams() {
      const { appid, userid, username } = this.$route.query;
      let token = this.$route.query.token || "";
      token = token.replace(/ /g, "+");

      // if (!appid || !userid || !username || !token) {
      //   console.error("未获取到完整的自动登录参数");
      //   return null;
      // }

      return { token };
    },
    autoLogin(params) {
      this.$http.post("/api/autoLogin", params).then((data) => {
        if (data.code !== 200) {
          this.$message({
            message: data.msg,
            type: "error",
          });
        } else {
          localStorage.setItem("token", data.data.token);
          let userInfo = {
            account: data.data.username,
            password: "",
            type: 1,
          };
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          localStorage.setItem("username", data.data.username);
          this.$router.push({ path: "/" });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
